import React from 'react';
import { Table } from 'react-bootstrap';

const DatabaseErrorsTable = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 style={{ color: '#EA6759', fontSize: '16px' }}>Database Errors</h6>
      <Table 
        striped 
        bordered 
        hover 
        size="sm"
        style={{ 
          backgroundColor: 'rgba(116, 232, 199, 0.05)',
          color: 'white',
          borderColor: '#74E8C7'
        }}
      >
        <thead style={{ backgroundColor: 'rgba(116, 232, 199, 0.1)' }}>
          <tr>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Row</th>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Email</th>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Error</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error, index) => (
            <tr key={index} style={{ borderColor: '#74E8C7' }}>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>{error.row}</td>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>{error.email}</td>
              <td style={{ color: '#EA6759', borderColor: '#74E8C7' }}>{error.error}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DatabaseErrorsTable;